import React from 'react';
import { columnLink, columnName, columnTarget } from '@/constants/fields';
import VocabularyLinkRow from './VocabularyLinkRow';

const VocabularyLinksTableRows = ({ columns = [columnName, columnLink, columnTarget], entity = 'link', links }) => (
  links.map(({ uuid }) => (
    <VocabularyLinkRow
      key={`vocabulary_link_table_row_${uuid}`}
      columns={columns}
      entity={entity}
      linkUUID={uuid}
    />
  ))
);

export default VocabularyLinksTableRows;
